import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import DestinationTile from "@/components/site/DestinationTile";
import { usePageMeta } from "@/components/site/SEO";
import { DESTINATIONS } from "@/content/destinations";

export default function ComingSoon() {
  usePageMeta(
    "Coming Soon",
    "Future Wandering Glider Experiences destinations: Pondicherry, Jaipur, Hampi and Ladakh in India, and Japan, South Korea and Indonesia internationally.",
  );

  return (
    <>
      <PageHero
        eyebrow="Coming Soon"
        title="Where we wander next"
        intro="New journeys are taking shape in India and beyond. Each is still being walked, mapped and imagined, so here is simply a sense of direction."
      />

      <section className="container-x pb-16" data-testid="coming-soon-india">
        <Reveal>
          <h2 className="mb-12 text-2xl font-medium tracking-tight sm:text-3xl">India</h2>
        </Reveal>
        <div className="grid gap-x-12 gap-y-16 sm:grid-cols-2">
          {DESTINATIONS.india.map((destination, i) => (
            <DestinationTile key={destination.id} destination={destination} delay={i * 0.06} />
          ))}
        </div>
      </section>

      <section className="container-x py-16 sm:py-20" data-testid="coming-soon-international">
        <Reveal>
          <h2 className="mb-12 border-t border-line pt-16 text-2xl font-medium tracking-tight sm:text-3xl">
            International
          </h2>
        </Reveal>
        <div className="grid gap-x-12 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {DESTINATIONS.international.map((destination, i) => (
            <DestinationTile key={destination.id} destination={destination} delay={i * 0.06} />
          ))}
        </div>
      </section>

      <section className="container-x pb-24 pt-8 sm:pb-32" data-testid="coming-soon-closing">
        <Reveal>
          <div className="max-w-2xl border-t border-line pt-16">
            <h2 className="text-3xl font-medium leading-tight tracking-tight sm:text-4xl">
              Looking for something different?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink/80">
              Let's create a journey around your school, your students and what you're curious to
              explore.
            </p>
            <Link
              to="/start-your-journey?journey=coming-soon"
              data-testid="coming-soon-conversation-cta"
              className="mt-9 inline-flex items-center gap-2 bg-pine px-8 py-4 text-base font-medium text-canvas transition-colors duration-300 hover:bg-pinedeep"
            >
              Start a Conversation
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
